import { useContext, useEffect } from "react";
import SeleccionContext from "../../../../context/Seleccion/SeleccionContext";
import ListadoCandidatoSeleccionado from "./CandidatoSeleccionado/ListadoCandidatoSeleccionado";

const TablaRegistroSeleccionado = () => {
  const {
    toasts, 
    getListaGeneral, 
    getExclusiones,
    getToken,
    token,
  } = useContext(SeleccionContext);

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (token) {
      getListaGeneral({token});
      getExclusiones({token});
    }
  }, [token]);

  return (
    <>
      {toasts}
      <ListadoCandidatoSeleccionado />
    </>
  );
};

export default TablaRegistroSeleccionado;
